import { render, staticRenderFns } from "./edit-pwd.vue?vue&type=template&id=5dd21314&scoped=true&"
import script from "./edit-pwd.vue?vue&type=script&lang=js&"
export * from "./edit-pwd.vue?vue&type=script&lang=js&"
import style0 from "./edit-pwd.vue?vue&type=style&index=0&id=5dd21314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd21314",
  null
  
)

export default component.exports